module.exports = __webpack_public_path__ + "static/media/icon-review.25e40b53.svg";